<template>
  <form>
    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <label for="exampleInputPassword1" class="form-label">Name <span class="text-danger">*</span></label>
          <input type="text" class="form-control" id="exampleInputPassword1" placeholder="Enter Your Branch name" />
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label for="branch-slug" class="form-label">Slug<span class="text-danger">*</span></label>
          <input type="text" class="form-control" id="branch-slug" placeholder="Auto Generated By Branch Name" />
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label for="exampleInputEmail1" class="form-label">Address line 1<span class="text-danger">*</span></label>
          <input type="text" class="form-control" id="exampleInputEmail1" />
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label for="exampleInputPassword1" class="form-label">Address line 2 (optional)</label>
          <input type="text" class="form-control" id="exampleInputPassword1" />
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label for="exampleInputEmail1" class="form-label">Postal Code<span class="text-danger">*</span></label>
          <input type="number" class="form-control" id="exampleInputEmail1" />
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label for="exampleInputPassword1" class="form-label">City<span class="text-danger">*</span></label>
          <input type="text" class="form-control" id="exampleInputPassword1" />
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label for="exampleInputEmail1" class="form-label">State<span class="text-danger">*</span></label>
          <input type="text" class="form-control" id="exampleInputEmail1" />
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label for="exampleInputPassword1" class="form-label">Country<span class="text-danger">*</span></label>
          <input type="text" class="form-control" id="exampleInputPassword1" />
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label for="exampleInputEmail1" class="form-label">Latitude (optional)</label>
          <input type="text" class="form-control" id="exampleInputEmail1" placeholder="Enter Latitude" />
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label for="exampleInputPassword1" class="form-label">Longitude (optional)</label>
          <input type="text" class="form-control" id="exampleInputPassword1" placeholder="Enter Longitude" />
        </div>
      </div>
      <small>Hint: Latitude & Longitude helps to find your salon by map</small>
    </div>
  </form>
</template>
